import { lineStyleForMode, primaryRouteMode } from "./routeViewModes";

export type RouteLineStyle = "solid" | "solid_thin" | "dashed" | "dotted";

type RouteViewsEnabled = {
  DEFAULT: boolean;
  POINT_TO_POINT: boolean;
  SNAP_TO_ROAD: boolean;
  DIRECTIONS_SERVICE: boolean;
};

// Which view the drawn line takes its styling from. Route views stack, so
// with more than one ticked this is the primary - the extra ones are drawn
// as separate comparison lines. Precedence lives in routeViewModes so
// geometry and styling can no longer disagree about which view won.
export const resolveRouteLineStyle = (
  routeViewsEnabled: RouteViewsEnabled | undefined
): RouteLineStyle =>
  lineStyleForMode(primaryRouteMode(routeViewsEnabled));

// Google Polyline options per style. The dashed and dotted views hide the
// line itself and draw symbols along it instead, which is why their
// strokeOpacity is 0 - the icons carry the colour.
export const strokeOptionsForStyle = (style: RouteLineStyle) => {
  switch (style) {
    case "dashed":
      return {
        strokeOpacity: 0,
        strokeWeight: 2,
        icons: [
          {
            icon: { path: "M 0,-1 0,1", strokeOpacity: 1, scale: 2 },
            offset: "0",
            repeat: "10px",
          },
        ],
      };
    case "dotted":
      return {
        strokeOpacity: 0,
        strokeWeight: 2,
        icons: [
          {
            icon: { path: "M 0,0 0,0", strokeOpacity: 1, scale: 3 },
            offset: "0",
            repeat: "5px",
          },
        ],
      };
    case "solid_thin":
      return { strokeOpacity: 0.85, strokeWeight: 1.5, icons: [] as any[] };
    case "solid":
    default:
      return { strokeOpacity: 0.85, strokeWeight: 2.5, icons: [] as any[] };
  }
};
